import React, { useEffect, useState, useRef } from "react";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import {
  SCORE_QR_KEY,
  encryptTardy,
  getTardyScoreCategory,
} from "../../services/ScoreService";
import { getQrBaseUrl } from "../../services/QrService";
import SETTINGS from '../../settings.json';

const GenerateTardyQr = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_teacher, setTeacher] = useState({
    last_name: "",
    first_name: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [getTardyScoreCategory(_school, _jwt), getQrBaseUrl(_school, _jwt)];

    Promise.all(promises).then((results) => {
      let result = results[0];

      setTeacher(result.data.teacher);

      const encrypted = encryptTardy(
        SCORE_QR_KEY,
        result.data.teacher.eid,
        result.data.category.id,
      );
 
      const baseUrl = results[1];
      setQrUrl(baseUrl + `/student/tardy/qr/${encrypted}`);
      setShowProgress(false);
      setSearchPerformed(true);
    });

  };

  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={512} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Tardy QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={`Tardy QR Code`} />
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell variant="head">Teacher</TableCell>
                <TableCell>
                  {_teacher.first_name} {_teacher.last_name}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p>
            <a href={_qrUrl}>Link</a>
            <br/>
            {SETTINGS.version}
          </p>
        </Box>
      </Container>
    </>
  );
};

export default GenerateTardyQr;
